function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48.14,0H1.86C.79,0,0,.86,0,1.86v46.28c0,1.07.86,1.86,1.86,1.86h46.28c1.07,0,1.86-.86,1.86-1.86V1.86C50,.79,49.14,0,48.14,0ZM49,48.14c0,.42-.32.86-.86.86H1.86c-.42,0-.86-.32-.86-.86V1.86c0-.42.32-.86.86-.86h46.28c.42,0,.86.32.86.86v46.28Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.54,14.81H4.95c-.52,0-.95.43-.95.95v18.59c0,.52.43.95.95.95h18.59c.52,0,.95-.43.95-.95V15.76c0-.52-.43-.95-.95-.95ZM23.49,34.3l-18.49.05-.05-18.54,18.54-.05s0,18.54,0,18.54Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.19,33.69h16.17c.32,0,.58-.26.58-.58v-16.17c0-.32-.26-.58-.58-.58H6.19c-.32,0-.58.26-.58.58v16.17c0,.32.26.58.58.58ZM6.8,17.55h14.95v14.95H6.8v-14.95Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M44.91,14.81h-18.59c-.52,0-.95.43-.95.95v18.59c0,.52.43.95.95.95h18.59c.52,0,.95-.43.95-.95V15.76c0-.52-.43-.95-.95-.95ZM44.85,34.3l-18.49.05-.05-18.54,18.54-.05v18.54Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M27.53,33.53h16.17c.22,0,.39-.17.39-.39v-16.17c0-.22-.17-.39-.39-.39h-16.17c-.22,0-.39.17-.39.39v16.17c0,.22.17.39.39.39ZM28.14,17.58h14.95v14.95h-14.95s0-14.95,0-14.95Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M35.61,19.77c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.38-5.29-5.29-5.29ZM35.61,29.36c-1.76,0-3.27-1.06-3.93-2.58-.33-.85-.42-1.77-.25-2.66.43-1.91,2.14-3.35,4.18-3.35,2.37,0,4.29,1.93,4.29,4.29s-1.93,4.29-4.29,4.29h0Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.19,24.68c-.36,0-.64.29-.64.64s.29.64.64.64.64-.29.64-.64-.29-.64-.64-.64Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M37.94,24.68c-.36,0-.64.29-.64.64s.29.64.64.64.64-.29.64-.64-.29-.64-.64-.64Z"
});

function SvgJungQuelleSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJungQuelleSwitch);
export default __webpack_public_path__ + "static/media/jung_quelle_switch.7182d9aa8f62a48345c2e868e8b01300.svg";
export { ForwardRef as ReactComponent };